export const PERIOD_IS_DISABLED_ERROR_MESSAGE = 'Period is not active';

export default {
    PERIOD_IS_DISABLED_ERROR_MESSAGE,
};
